module.exports = __webpack_public_path__ + "media/images/team/SHorun-0b7419d474accdc1cde40add6be42647.jpg";